export * from './delete-datei-art-request.interface';
export * from './delete-datei-art-response.interface';
export * from './delete-datei-art.shapes';
